<template>
  <div v-if="active">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Step",
  props: {
    name: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      active: false,
      isComplete: false,
      ctx: {}
    };
  },
  methods: {
    activate() {
      this.active = true;
      this.isComplete = false;
    },
    deactivate() {
      this.active = false;
    },
    complete() {
      this.isComplete = true;
    },
    unwind() {
      this.isComplete = false;
    },
    done(ctx) {
      this.$parent.next(ctx);
    }
  }
};
</script>
